<div class="spinner-container">
  <p-progressSpinner
    class="signin-spinner"
    [style]="{ height: '60px', width: '60px' }"
    strokeWidth="3"
    animationDuration="1s"
  ></p-progressSpinner>
</div>
<p-toast></p-toast>
